import type { GenerateFillLayoutOptions, TileLayoutResult } from '../tile-layout-types';

import { createFillLayoutContext, finalizeFillLayout } from './fill-layout-context';

/** Empty interior — no fill tiles. Useful for pathing/debug baselines. */
export function generateOpenLayout(options: GenerateFillLayoutOptions): TileLayoutResult {
  const ctx = createFillLayoutContext(options);
  return finalizeFillLayout(ctx, 'open', 0, 0);
}
